import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import _tail from 'lodash/tail';

export const formatDeliveryTime = timeInSec => {
  const t = fromUnixTime(timeInSec);
  return format(t, 'd MMM y');
};

export const ordersToWaybillData = orders => {
  const data = [];
  orders.forEach(o => {
    _tail(o.steps).forEach((step, i) => {
      data.push({ order: o, dropoffStepIndex: i + 1 });
    });
  });
  return data;
};

export default {};
